/* eslint-disable */

import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
// import { useTheme as useNextTheme } from "next-themes";
// import { Switch, useTheme } from "@nextui-org/react";
import CherryK from "../../assets/img/cherryk.png";
import { Link, useLocation } from "react-router-dom";
// import { Badge, Grid } from "@nextui-org/react";
// import { Badge } from "@nextui-org/react";
import { Badge } from "@mui/material";
import {
  FaFileMedical,
  FaDatabase,
  FaAngleDown,
  FaRegUser,
  FaClipboardCheck,
  FaPowerOff,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSuccess } from "../../redux/authRedux";
import Swal from "sweetalert2";

function SideBar() {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [accHOCount, setAccHOCount] = useState("");
  const [medHOCount, setMedHOCount] = useState("");
  const [proHOCount, setProHOCount] = useState("");

  const [accountLists, setAccountLists] = useState([]);
  const [count, setCount] = useState("");
  const [stockReqLists, setStockReqLists] = useState([]);
  const [reqCount, setReqCount] = useState("");
  const [stockTranLists, setStockTranLists] = useState([]);
  const [tranCount, setTranCount] = useState("");

  const user = useSelector((state) => state.auth.user);
  // console.log(user?.user?.role, 'role')
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    Swal.fire({
      title: "Success",
      text: "successfully Logout!",
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
    }).then(function () {
      dispatch(logoutSuccess());
      navigate("/");
    });
  };
  const divStyles = {
    boxShadow: "1px 2px 9px #BBB9B9",
  };

  useEffect(() => {
    const getAccountLists = async () => {
      try {
        api.get("accounting-lists").then((res) => {
          setAccountLists(res.data.list);
          setCount(res.data.list.length);
          // console.log(res.data.data, 'reorder')
        });

        // dispatch(setList("success"));
      } catch (err) {}
    };
    const getStockReqLists = async () => {
      try {
        const res = await api.get("stock-requests");
        setStockReqLists(res.data.list);
        setReqCount(res.data.list.filter((el) => !el.relatedTransfer).length);
        // setTreatmentLists(res.data.list)

        console.log(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    const getStockTranLists = async () => {
      try {
        const res = await api.get(
          "stock-transfers",
          //'http://localhost:9000/api/treatments'
        );
        setStockTranLists(res.data.list);
        setTranCount(res.data.list.length);
        // setTreatmentLists(res.data.list)

        console.log(res.data.list, "tran");
      } catch (err) {
        alert(err.message);
      }
    };
    const getProUnitLists = async () => {
      try {
        const res = await api.get("procedure-items?limit=30");
        // setProHOItemList(
        //   res.data.list.filter(el =>el.currentQuantity === 0)
        // )
        setProHOCount(
          res.data.list.filter((el) => el.currentQuantity <= el.reOrderQuantity)
            .length,
        );
        // console.log(res.data.list, 'pro list')
        // console.log(setProUnitLists.reOrderQuantity)
        // setProId(res.data.list._id)
      } catch (err) {
        alert(err.message);
      }
    };

    const getMedUnitLists = async () => {
      try {
        const res = await api.get("medicine-items?limit=30");
        // setMedHOItemList(
        //   res.data.list.filter(el =>el.currentQuantity <= el.reOrderQuantity)
        // )
        // console.log(
        //   res.data.list.filter(el => el.reOrderQuantity >= el.currentQuantity),
        //   'ori med list'
        // )
        setMedHOCount(
          res.data.list.filter((el) => el.currentQuantity <= el.reOrderQuantity)
            .length,
        );
      } catch (err) {
        alert(err.message);
      }
    };

    const getProAssLists = async () => {
      try {
        const res = await api.get("accessory-items?limit=30");
        // setAccHOItemList(
        //   res.data.list.filter(el =>el.currentQuantity <= el.reOrderQuantity)
        // )
        // console.log(res.data.list, 'pro ass list')
        setAccHOCount(
          res.data.list.filter((el) => el.currentQuantity <= el.reOrderQuantity)
            .length,
        );
      } catch (err) {
        alert(err.message);
      }
    };

    // getProAssLists();

    // getMedUnitLists();
    // getProUnitLists();

    // getStockReqLists();
    // getStockTranLists();

    // getAccountLists();
  }, []);

  return (
    <aside className="menu main-sidebar rounded" style={divStyles}>
      {/* <!-- Brand Logo --> */}
      {/* {{-- <a href="index3.html" classNameName="brand-link">
              <img src="{{asset('image/logo.jpg')}}" alt="K-win Technology" classNameName="brand-image img-circle"
                   style="opacity: .8;margin-top:10px;">
                </a> --}} */}
      <h3 className="brand-text font-weight-bold shadow-1-strong text-center mt-2 mr-5 py-2">
        Htun Tauk Distribution
      </h3>
      {/* <img src={CherryK} alt='' width='210px' height='130px' /> */}

      {/* 
            <!-- Sidebar --> */}
      <div className="sidebar mt-2">
        <nav className="mt-3">
          <ul className="nav sidebar-nav nav-pills nav-sidebar flex-column">
            {/* //admin */}
            <li className="ml-3">
              <p
                data-bs-toggle="collapse"
                href="#collapseExample"
                role="button"
                aria-expanded="true"
                aria-controls="#click"
                className="d-flex justify-content-between"
              >
                <div className="">
                  <FaRegUser /> &nbsp; Admin &nbsp;
                </div>
                <b className="mr-5" id="click">
                  <FaAngleDown />
                </b>
              </p>
            </li>
            <div className="collapse" id="collapseExample">
              <ul style={{ listStyle: "none", color: "white" }}>
                {/* <li className="nav-item">
                  <Link to="/stock" className="nav-link text-dark">
                    <p>Stock Count & Price</p>
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link to="/stock-count-price" className="nav-link text-dark">
                    <p>Stock Count & Price</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/stock-history-list" className="nav-link text-dark">
                    <p>Stock History</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/stock-req" className="nav-link">
                    <Badge badgeContent={reqCount + "+"} color="error">
                      <p>Stock Request</p>
                    </Badge>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/stock-tran" className="nav-link">
                    <Badge badgeContent={tranCount + "+"} color="error">
                      <p>Stock Transfer</p>&nbsp;
                    </Badge>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/purchase" className="nav-link ">
                    <p>Purchase Request </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/purchase-voucher" className="nav-link ">
                    <p>Purchase Voucher </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/pur-tranlist" className="nav-link ">
                    <p>Purchase Approve List </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/issue-list" className="nav-link ">
                    <p>Issue List (HO) </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/receive-pos" className="nav-link ">
                    <p>Receive From POS </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/supplier" className="nav-link ">
                    <p>Supplier List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  {/* <Link to="/stock-list" className="nav-link ">
                    <p>Log List</p>
                  </Link> */}
                  {/* <Link to="/stock-history-list" className="nav-link ">
                    <p>Log List</p>
                  </Link> */}
                </li>
                {/* <li className='nav-item'>
                  <Link to='/fix_asset' className='nav-link '>
                    <p>Fixed Asset List</p>
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link to="/medicineSale" className="nav-link ">
                    <p> Sale Report</p>
                  </Link>
                </li>
                {/* <li className='nav-item'>
                  <Link to='/knas' className='nav-link '>
                    <p>K-Nas Voucher List</p>
                  </Link>
                </li> */}
                {/* <li className='nav-item'>
                  <Link to='/treatSale' className='nav-link '>
                    <p>Treatment Sales Report</p>
                  </Link>
                </li> */}
                {/* <li className='nav-item'>
                  <Link to='/doctor' className='nav-link '>
                    <p>Doctor List</p>
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link to="/discount" className="nav-link ">
                    <p>Discount List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/member" className="nav-link ">
                    <p>Member List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/reorder" className="nav-link ">
                    <Badge
                      badgeContent={medHOCount + proHOCount + accHOCount + "+"}
                      color="error"
                    >
                      <p>Reorder List &nbsp;</p>
                    </Badge>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/package" className="nav-link ">
                    <p>Package List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/sale-return" className="nav-link ">
                    <p>Sales Return List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/top10" className="nav-link ">
                    <p>Top 10 List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/advance" className="nav-link ">
                    <p>Advance List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/user" className="nav-link ">
                    <p>User List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/customer" className="nav-link ">
                    <p>Customer List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/expDateList" className="nav-link ">
                    <p>Expeired Date List</p>
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <Link to="/stock-history" className="nav-link ">
                    <p>Stock History</p>
                  </Link>
                </li> */}
              </ul>
            </div>

            <li className="nav-item ml-3">
              <p
                data-bs-toggle="collapse"
                href="#accountData"
                role="button"
                aria-expanded="false"
                aria-controls="accountData"
                className="d-flex justify-content-between"
              >
                <div>
                  <FaDatabase /> &nbsp; Account Data &nbsp;
                </div>
                <b className="mr-5">
                  <FaAngleDown />
                </b>
              </p>
            </li>

            <div className="collapse" id="accountData">
              <ul style={{ listStyle: "none" }}>
                <li className="nav-item">
                  <Link to="/account_list" className="nav-link">
                    <p>Account Lists &nbsp;</p> &nbsp;
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/acc_type" className="nav-link">
                    <p>Account Type</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/head" className="nav-link">
                    <p>Heading Type</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/expense" className="nav-link ">
                    <p>Expense List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/income" className="nav-link ">
                    <p>Income List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/currency" className="nav-link ">
                    <p>Currency List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/bank" className="nav-link ">
                    <p>Bank List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/transfer-list" className="nav-link ">
                    <p>Transfer List</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/all-tran" className="nav-link ">
                    <p>All Transaction List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/journal-list" className="nav-link">
                    <p>Journal Entry</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/bc-report" className="nav-link">
                    <p>Bank / Cash Report</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/acc-report" className="nav-link">
                    <p>Account Report</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/transferreport-list" className="nav-link">
                    <p>Transfer from Account Report</p>
                  </Link>
                </li>
              </ul>
            </div>

            <li className="nav-item ml-3">
              <p
                data-bs-toggle="collapse"
                href="#reportData"
                role="button"
                aria-expanded="false"
                aria-controls="reportData"
                className="d-flex justify-content-between"
              >
                <div>
                  <FaClipboardCheck /> &nbsp; Report
                </div>
                <b className="mr-5">
                  <FaAngleDown />
                </b>
              </p>
            </li>
            <div className="collapse" id="reportData">
              <ul style={{ listStyle: "none" }}>
                <li className="nav-item">
                  <Link to="/profit-and-loss" className="nav-link">
                    <p>Profit And Loss</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/balance_sheet" className="nav-link">
                    <p>Balance Sheet</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/trail_bal" className="nav-link">
                    <p>Trail Balance</p>
                  </Link>
                </li>
              </ul>
            </div>
            {/* Master Data */}
            {/* {user.user.role === 'Admin' && (
              <> */}
            <li className="nav-item ml-3">
              <p
                data-bs-toggle="collapse"
                href="#masterData"
                role="button"
                aria-expanded="false"
                aria-controls="masterData"
                className="d-flex justify-content-between"
              >
                <div>
                  <FaFileMedical /> &nbsp; Master Data
                </div>
                <b className="mr-5">
                  <FaAngleDown />
                </b>
              </p>
            </li>
            <div className="collapse" id="masterData">
              <ul style={{ listStyle: "none" }}>
                <li className="nav-item">
                  <Link to="/category" className="nav-link">
                    <p>Category</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/sub_category" className="nav-link">
                    <p>Sub Category</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/brand" className="nav-link">
                    <p>Brand List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/product_list" className="nav-link">
                    <p>Products List</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/unit-con" className="nav-link">
                    <p>Unit Convention</p>
                  </Link>
                </li>

                {/* <li className='nav-item'>
                  <Link to='/pro-access' className='nav-link'>
                    <p>Procedure Accessory</p>
                  </Link>
                </li> */}
                {/* <li className='nav-item'>
                  <Link to='/gen' className='nav-link'>
                    <p>General Items</p>
                  </Link>
                </li> */}

                {/* <li className='nav-item'>
                  <Link to='/machine' className='nav-link'>
                    <p>Machine</p>
                  </Link>
                </li> */}
                {/* <li className='nav-item'>
                  <Link to='/treatC' className='nav-link'>
                    <p>Treatment</p>
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link to='/dental-treatment' className='nav-link'>
                    <p>Dental Treatment</p>
                  </Link>
                </li> */}
                {/* <li className="nav-item">
                  <Link to="/pro_medicine" className="nav-link">
                    <p>Treatment List</p>
                  </Link>
                </li> */}
              </ul>
            </div>
            {/* </>
            )} */}

            <li className="nav-item">
              <a className="nav-link" onClick={logout}>
                <FaPowerOff />

                <span className="ml-2">Logout</span>
              </a>
            </li>

            <li className="nav-item">
              {/* The current theme is: {type}
              <Switch
                checked={isDark}
                onChange={e => setTheme(e.target.checked ? 'dark' : 'light')}
              /> */}
              {/* <Link
                to="http://clinicdenovopos.kwintechnologies.com/dashboard"
                className="nav-link ">
                <p>
                  <FaCashRegister /> &nbsp; POS
                </p>
              </Link> */}
            </li>
            {/* <li className='nav-item'>
              <a href='' className='nav-link'>
                <p>
                  &nbsp;Logout
                </p>
              </a>
            </li> */}
          </ul>
        </nav>
        {/* <!-- /.sidebar-menu --> */}
      </div>
      {/* <!-- /.sidebar --> */}
    </aside>
  );
}
export default SideBar;
